import { Injectable, signal } from '@angular/core';
import { OverlayBubble } from './overlay-tray.model';

@Injectable({ providedIn: 'root' })
export class OverlayTrayService {
  #bubbles = signal<OverlayBubble[]>([]);
  bubbles = this.#bubbles.asReadonly();

  register(bubble: OverlayBubble) {
    this.#bubbles.update((list) => {
      const without = list.filter((b) => b.id !== bubble.id);
      return [ ...without, bubble ];
    });
  }

  unregister(id: string) {
    this.#bubbles.update((list) => list.filter((b) => b.id !== id));
  }
}
